import * as _4 from 'lodash4';
import { AppointmentSchedulingConfiguration } from '../../config/appointment_scheduling_configuration';

export class ScheduleAppointmentsLink {
  private appointmentScheduling: any;
  private buttonText: string;
  private aesthetic: string = 'button';
  private flags: any;
  private showPrefixText: boolean;

  constructor(
    private appConfigModel: any,
    private FEATURE_APPOINTMENTS: string,
    private ngAppointmentSchedulingConfiguration: AppointmentSchedulingConfiguration,
    private $state: ng.ui.IStateService
  ) {
    this.appointmentScheduling = {
      icon: {
        type: 'calender',
        theme: 'tertiary-9'
      },
      text: {
        title: 'Talk to an advisor',
        subTitle: 'Any questions? Schedule some time to meet with an advisor.'
      },
      action: {
        state: 'my.appointments',
        params: {}
      }
    };
  }

  $onInit() {
    this.buttonText = this.buttonText || 'Schedule an Appointment';
    this.aesthetic = this.aesthetic || 'button';
    this.flags = {
      isAppointmentsFeatureEnabled: this.appConfigModel.isFeatureEnabled(this.FEATURE_APPOINTMENTS)
    };
    this.showPrefixText = !!this.showPrefixText;
  }

  isFixed() {
    return !this.showPrefixText;
  }

  goToAppointments() {
    this.$state.go('my.appointments');
  }

  get isAestheticButton() {
    return _4.toLower(this.aesthetic) === 'button';
  }

  get isAestheticLink() {
    return !this.isAestheticButton;
  }
}

angular
  .module('capability-ng-appointments')
  .component('scheduleAppointmentsLink', {
    bindings: {
      buttonText: '@',
      showPrefixText: '<',
      aesthetic: '@'
    },
    templateUrl: 'capability-ng-appointments/src/components/appointments_link/appointments_link.html',
    controller: 'scheduleAppointmentsLinkController'
  })
  .controller('scheduleAppointmentsLinkController', ScheduleAppointmentsLink);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/components/appointments_link/appointments_link.ts